{
  "bindings": {
    "banner-cta:tap": {
      "flow": "navigateToSignup"
    }
  }
}
